/**
 * Re-exports the canonical {@link PromptType} enum from the generated GraphQL schema types.
 * The parsePromptType helper handles case-insensitive parsing for backward compatibility.
 *
 * @see {@link @core/graphql/types/schema} for the single source of truth.
 * @module PromptType
 */
import { PromptType } from '@core/graphql/types/schema';

export { PromptType };

/**
 * Parse a string value into a PromptType enum value.
 * Returns undefined if the value doesn't match any known prompt type.
 */
export function parsePromptType(value: string | null): PromptType | undefined {
  if (!value) {
    return undefined;
  }

  const normalized = value.toLowerCase();
  const mapping: Record<string, PromptType> = {
    classification: PromptType.Classification,
    moderation: PromptType.Moderation,
    username: PromptType.Username,
  };

  return mapping[normalized];
}
